import swal from 'sweetalert';

export default async function SweetAlert(props) {

    var { title,type, text } = props

    return swal({
      // title: title,
      text: text,
      icon: type,
    });

    
    
}

